/**
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import Vue from 'vue';
import WebInstaller from './views/WebInstaller.vue';
const SetupVue = Vue.extend(WebInstaller);
new SetupVue().$mount('#content');
